import { useRef } from 'react';

import { useLegalClientBeneficiarySaveAddresses } from 'api/requests/onboarding/legal/beneficiary';
import { useFilesUpload, useServerErrorNotify } from 'hooks';
import { OnboardingRegistrationAddressFormType } from 'modules/onboarding/common/forms/onboardingRegistrationAddressForm';
import {
  getInitialData,
  getSubmitData,
} from 'modules/onboarding/common/helpers/registrationAddress';
import { useOnboardingCountries } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useRegistrationAddress = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const {
    saveAddresses,
    loading: submitLoading,
    error,
  } = useLegalClientBeneficiarySaveAddresses();

  const initialData = useRef(
    getInitialData(data.legalClientBeneficiary)
  ).current;

  const initialValues = useRef(initialData?.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData?.files);

  const onSubmit = async (values: OnboardingRegistrationAddressFormType) => {
    if (values) {
      const submitData = getSubmitData(values, true);
      await saveAddresses(
        data.legalClient.id,
        data.legalClientBeneficiary.id,
        submitData
      );
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    initialValues,
    countries,
    countriesLoading,
    files,
    submitLoading,
    submitDisabled,
    onSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
  };
};
